import React from 'react';
import { Card, Checkbox, Title } from '@nimbus-ds/components';
import { Stack } from 'commons/components';
import { InterfaceNameBooleanValue } from 'commons/types';
import useTranslationOrders from '../../../../../useTranslationOrders';
import {
  RefundAttributes,
  RefundAttributesTypes,
} from '../../../hooks/useRefundOrder/useRefundOrder';

interface Attributes {
  values: RefundAttributes;
  onChange: (data: InterfaceNameBooleanValue) => void;
  disableCancelOrderCheckbox: boolean;
}

function RefundConfigurationsCard({
  values,
  onChange,
  disableCancelOrderCheckbox,
}: Readonly<Attributes>): React.JSX.Element {
  const t = useTranslationOrders('refund.setUpRefundDetails.configurations');

  const onChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) =>
    onChange({ name: event.target.name, value: event.target.checked });

  return (
    <Card>
      <Card.Header>
        <Title as="h3">{t('title')}</Title>
      </Card.Header>
      <Card.Body>
        <Stack column align="stretch">
          {values.type === RefundAttributesTypes.TOTAL && (
            <>
              <Checkbox
                name="cancelsOrder"
                label={t('checkbox.closesOrder')}
                checked={values.cancelsOrder}
                onChange={onChangeCheckbox}
                disabled={disableCancelOrderCheckbox}
              />
              <Checkbox
                name="returnsStock"
                label={t('checkbox.returnsStock')}
                onChange={onChangeCheckbox}
                checked={values.returnsStock}
              />
            </>
          )}
          <Checkbox
            name="notifiesConsumer"
            label={t('checkbox.notifiesConsumer')}
            onChange={onChangeCheckbox}
            checked={values.notifiesConsumer}
          />
        </Stack>
      </Card.Body>
    </Card>
  );
}

export default RefundConfigurationsCard;
